// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__79ff8ac7","labelGroup":"labelGroup__79ff8ac7","label":"label__79ff8ac7","diff":"diff__79ff8ac7","datePicker":"datePicker__79ff8ac7"};